var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _g7, _path14, _path15, _g8, _path16, _path17, _g9, _path18, _path19, _g10, _path20, _path21, _g11, _path22, _path23, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 44,
    viewBox: "0 0 227 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 8,
    width: 7,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78548 8.0874H8.3588V18.8903H2.78548V8.0874Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 8,
    width: 7,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02539 8.0874H2.78548V18.8743C5.37706 16.4795 8.02539 12.8724 8.02539 8.0874Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.38574H35.1117V39.4147H0V5.38574Z",
    fill: "#ED1C24"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 25,
    width: 7,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78548 25.3711H8.3588V36.7148H2.78548V25.3711Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 25,
    width: 7,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78548 25.7974V36.5842H8.02539C8.02539 31.7992 5.37706 28.1899 2.78548 25.7974Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.38525H35.1117V39.4142H0V5.38525Z",
    fill: "#ED1C24"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 17,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23733 8.0874H20.5813V36.7149H4.23733V8.0874Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 17,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94306 22.3347C9.94779 22.3301 20.1084 17.4626 20.1084 8.0874H14.4902C14.4902 8.0874 15.3485 16.4382 4.32481 22.3347C15.3485 28.2334 14.4902 36.5843 14.4902 36.5843H20.1084C20.1084 27.2068 9.95489 22.3416 9.94306 22.3347Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.62939e-06 5.38574H35.1117V39.4147H-7.62939e-06V5.38574Z",
    fill: "#ED1C24"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 17,
    height: 29
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.344 8.0874H32.3238V36.7149H16.344V8.0874Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 17,
    height: 29
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1914 8.0874H26.5732C26.5732 8.0874 27.4315 16.4382 16.4078 22.3347C27.4315 28.2334 26.5732 36.5843 26.5732 36.5843H32.1914C32.1914 27.2068 22.0308 22.3416 22.0261 22.3347C22.0308 22.3301 32.1914 17.4626 32.1914 8.0874Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.62939e-06 5.38574H35.1117V39.4147H-7.62939e-06V5.38574Z",
    fill: "#ED1C24"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 9,
    width: 22,
    height: 27
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5573 9.38672H61.744V35.2001H40.5573V9.38672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 9,
    width: 22,
    height: 27
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1414 30.3323C54.3854 30.3323 55.7001 29.0948 55.7001 27.2454C55.7001 25.3984 54.3901 24.1609 52.1414 24.1609H46.3364V30.3323H52.1414ZM51.3871 19.4377C53.3001 19.4377 54.3854 18.3469 54.3854 16.8986C54.3854 15.4502 53.3001 14.3525 51.3871 14.3525H46.3364V19.4377H51.3871ZM40.7205 35.0486V9.62939H51.7678C57.0077 9.62939 60.1905 12.7163 60.1905 16.3463C60.1905 18.379 59.2919 19.6486 58.391 20.4873C57.8661 20.9571 57.2655 21.3559 56.6294 21.6102C57.5279 21.8646 58.3508 22.3023 59.0649 22.8477C60.2614 23.8263 61.4981 25.3159 61.4981 27.7863C61.4981 31.7463 58.0954 35.0486 52.5127 35.0486H40.7205Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2759 35.0418L61.4933 35.3902L61.9426 9.63871L40.7276 9.28809L40.2759 35.0418Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 9,
    width: 28,
    height: 27
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3493 9.38672H89.5893V35.2001H62.3493V9.38672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 9,
    width: 28,
    height: 27
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0953 24.3396L75.9883 15.9842H75.8369L72.7346 24.3396H79.0953ZM62.6236 35.0486L72.7346 9.62939H79.0953L89.2063 35.0486H83.2168L80.9681 29.2392H70.8618L68.6131 35.0486H62.6236Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1791 35.0416L89.1992 35.4861L89.6508 9.63843L62.6307 9.19385L62.1791 35.0416Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 9,
    width: 19,
    height: 27
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.765 9.62939H98.3809V29.9634H92.765V9.62939ZM92.765 29.9634H110.547V35.0486H92.765V29.9634Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3204 35.0417L110.542 35.3419L110.991 9.63859L92.7697 9.33838L92.3204 35.0417Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 9,
    width: 29,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.987 9.38672H139.832V35.2001H111.987V9.38672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 9,
    width: 28,
    height: 27
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.708 29.8121C129.986 29.8121 133.412 26.4892 133.412 22.339C133.412 18.1888 129.986 14.8727 125.708 14.8727C121.431 14.8727 118.005 18.1888 118.005 22.339C118.005 26.4892 121.426 29.8121 125.708 29.8121ZM125.708 35.0531C117.955 35.0531 112.067 29.3102 112.067 22.3459C112.067 15.3792 117.955 9.62939 125.708 9.62939C133.462 9.62939 139.35 15.3746 139.35 22.339C139.35 29.3056 133.462 35.0486 125.708 35.0486V35.0531Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.623 35.0464L139.343 35.5024L139.794 9.63866L112.074 9.18262L111.623 35.0464Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 9,
    width: 25,
    height: 27
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.859 9.38672H166.467V35.2001H142.859V9.38672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 9,
    width: 25,
    height: 27
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.92 35.0486V9.62939H147.973L160.702 25.4259V9.62939H166.318V35.0486H161.265L148.536 19.2544V35.0486H142.92Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.478 35.0416L166.311 35.4335L166.76 9.63846L142.927 9.24658L142.478 35.0416Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 28,
    width: 8,
    height: 8
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.888 28.7466H175.547V35.1999H168.888V28.7466Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 29,
    width: 7,
    height: 7
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.016 35.0488C170.333 35.0488 169.018 33.7792 169.018 32.1407C169.018 30.5044 170.328 29.2349 172.016 29.2349C173.702 29.2349 175.012 30.5044 175.012 32.1407C175.012 33.7792 173.702 35.0488 172.016 35.0488Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.916 35.0464L175.01 35.1473L175.114 29.2371L169.02 29.1362L168.916 35.0464Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 9,
    width: 24,
    height: 27
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175.547 9.38672H198.549V35.2001H175.547V9.38672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 9,
    width: 24,
    height: 27
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.067 35.0486C180.325 35.0486 175.648 30.5088 175.648 23.9706V9.62939H181.262V23.9775C181.262 27.6075 183.657 29.9702 187.067 29.9702C190.477 29.9702 192.872 27.6075 192.872 23.9775V9.62939H198.485V23.9775C198.485 30.5156 193.806 35.0531 187.067 35.0531V35.0486Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.204 35.0463L198.478 35.429L198.93 9.63857L175.653 9.25586L175.204 35.0463Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 9,
    width: 23,
    height: 27
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.787 9.38672H224.579V35.2001H202.787V9.38672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_706_1646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_706_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 9,
    width: 22,
    height: 27
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M203.354 35.0486V29.9634L216.646 14.71H203.917V9.62939H223.758V14.7146L210.467 29.9634H224.132V35.0486H203.354Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_706_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.91 35.0418L224.127 35.3902L224.576 9.63871L203.361 9.28809L202.91 35.0418Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.4910dc4fe97c1cbbfa2001f1c9b0dcd2.svg";
export { ForwardRef as ReactComponent };